import React from "react";
import classNames from "classnames";
import styles from "./UploadFileDialog.module.scss";
import Button from "../Button/Button";
import ArchivoImg from "../../../assets/img/upload-dialog-select.svg";

const UploadFileBodyUpload = (
  {
    onFileSelectClick
  }
) => {
  return (
    <>
      <div className={styles.BodyUploadFileUpload}>

        <div className={classNames(styles.UploadZone, styles.JustifyContent)}>

          <div>
            <img id="ufbuBuscarImg" src={ArchivoImg}
                 alt={"Cargar archivo"}/>
          </div>

          <div>
            <Button
              id="ufbuSeleccionarArchivoBtn"
              name="seleccionarArchivoBtn"
              type="button"
              typeStyle="ghost"
              notFullWidth
              cssClassName={styles.UploadButton}
              onClick={onFileSelectClick}>
              Selecciona un archivo
            </Button>
          </div>

        </div>
      </div>
    </>
  );
};

export default UploadFileBodyUpload;
